import React, { useState, useEffect, useRef, useCallback } from "react";
import { View, Text, FlatList } from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from "rn-responsive-styles";
import { toast } from "react-toastify";
import { getLoginData } from "../../../utility/AppStoreData";
import { base_url, endpoints } from "../../../Api/configs";
import { ShowLoader } from "../../../common/ShowLoader";
import { MessageList, NoMessages } from "../../../common/CommonChatMessageLIst";
import { MessageInput } from "../../../common/CommonMessageInput";
import { CommonButton } from "../../../common/CommonButton";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import withErrorBoundary from "../../../utility/auth/withErrorBoundary";
import { fetchChatHistory } from "../../../services/chatAPI";
import Skeletons from "../../../Components/skeleton-components/Skeletons";

interface HelpChatComponentProps {
  deviceSize: DEVICE_SIZES;
  onChatTap: () => void;
  chatID: string;
  title: string;
}

export interface MessageData {
  user: string;
  conversationId: string;
  messageContent: string;
  messageId: string;
  timestamp: string;
}

const HelpChatComponent: React.FC<HelpChatComponentProps> = ({
  deviceSize,
  onChatTap,
  chatID,
  title,
}) => {
  const styles = useStyles();
  // const [messages, setMessages] = useState<MessageData[]>([]);
  // const flatListRef = useRef<FlatList<MessageData> | null>(null);
  // const [loginUserData, setLoginUserData] = useState<any>(null);
  // const [showLoader, setShowLoader] = useState<boolean>(false);

  // useEffect(() => {
  //   getLoginUserData((data) => {
  //     if (!chatID) return;

  //     chatGetHistoryAPI(() => {
  //       setTimeout(() => {
  //         if (flatListRef.current) {
  //           flatListRef.current.scrollToEnd({ animated: true });
  //         }
  //       }, 100);
  //     });
  //   });
  // }, [chatID]);

  // useEffect(() => {
  //   setTimeout(() => {
  //     if (flatListRef.current) {
  //       flatListRef.current.scrollToEnd({ animated: true });
  //     }
  //   }, 100);
  // }, [messages]);

  // const handleReceivedMessage = useCallback(
  //   (message: string) => {
  //     const json: any = message;
  //     if (json.conversationId === chatID) {
  //       const dict: MessageData = {
  //         user: json.user,
  //         conversationId: chatID,
  //         messageContent: json.messageContent,
  //         messageId: json.messageId,
  //         timestamp: json.timestamp,
  //       };
  //       setMessages((currentData) => [...currentData, dict]);
  //     }
  //   },
  //   [chatID]
  // );

  // const sendMessage = useWebSocket({
  //   screen: "web",
  //   chatID,
  //   accessToken: loginUserData?.AccessToken,
  //   onMessageReceived: handleReceivedMessage,
  // });

  // const handleSendMessage = useCallback(
  //   (message: string) => {
  //     if (!message.trim()) return;

  //     const actionData: SendMessagePayload = {
  //       action: "sendMessage",
  //       data: {
  //         message,
  //         chatId: chatID,
  //         accessToken: loginUserData?.AccessToken || "",
  //       },
  //     };
  //     sendMessage(actionData);

  //     const dict: MessageData = {
  //       user: loginUserData?.username || "Unknown",
  //       conversationId: chatID,
  //       messageContent: message,
  //       messageId: "",
  //       timestamp: new Date().toISOString(),
  //     };
  //     setMessages((currentData) => [...currentData, dict]);
  //     flatListRef.current?.scrollToEnd({ animated: true });
  //   },
  //   [chatID, loginUserData, sendMessage]
  // );

  // async function getLoginUserData(successResponse: (data: any) => void) {
  //   const data = await getLoginData();
  //   if (data) {
  //     setLoginUserData(data);
  //     successResponse(data);
  //   }
  // }

  // const chatGetHistoryAPI = async (successResponse: (data: any) => void) => {
  //   setShowLoader(true);
  //   const data = await getLoginData();
  //   const chatId = chatID;

  //   try {
  //     const response = await fetchChatHistory(data.AccessToken, chatId);

  //     if (response.statusCode === 200) {
  //       setMessages(response.body.messages);
  //       successResponse(response.body);
  //     } else {
  //       toast.error(response.body.error);
  //     }
  //   } catch (error) {
  //     toast.error(error.message);
  //   } finally {
  //     setShowLoader(false);
  //   }
  // };

  return (
    <View style={styles.chatBox}>
      <View style={styles.eventView}>
        {/* {showLoader ? (
          <View style={{ width: 380 }}>
            <Skeletons
              height={35}
              width={"218px"}
              style={{
                borderRadius: 10,
              }}
            />
            <Skeletons
              height={1}
              style={{
                borderRadius: 10,
                marginTop: 12,
              }}
            />
            <Skeletons
              height={500}
              style={{
                borderRadius: 10,
                marginTop: 12,
              }}
            />
          </View>
        ) : (
          <>
            <Text
              style={[
                deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                  ? AppFontStyle.BOLD_ANYBODY_24
                  : AppFontStyle.REGULAR_ANYBODY_18,
                { marginTop: 15, marginHorizontal: 5 },
              ]}
            >
              {title ? title : "Chat"}
            </Text>
            <View style={styles.separator} />
            <View style={styles.chatOuterView}>
              <CommonButton
                title="Chat"
                onTap={onChatTap}
                buttonStyle={styles.btnChat}
                textStyle={AppFontStyle.REGULAR_ANYBODY_12}
              />
              <View style={styles.separator} />
              <View style={styles.messageListContainer}>
                {messages.length !== 0 ? (
                  <MessageList
                    messages={messages}
                    loginUserData={loginUserData}
                    flatListRef={flatListRef}
                  />
                ) : (
                  <NoMessages deviceSize={deviceSize} />
                )}
              </View>
              <View style={styles.separator} />
              <MessageInput onSendMessage={handleSendMessage} />
            </View>
          </>
        )} */}
        No Data
      </View>
    </View>
  );
};

const useStyles = CreateResponsiveStyle(
  {
    eventView: {
      marginTop: 5,
      marginBottom: 5,
      alignSelf: "flex-end",
    },
    separator: {
      height: 1,
      backgroundColor: AppColors.grayColor_484848,
      marginVertical: 10,
    },
    messageContainer: {
      padding: 10,
      borderRadius: 5,
      marginVertical: 5,
      maxWidth: "50%",
    },
    messageListContainer: {
      minHeight: 350,
      maxHeight: 350,
      minWidth: 350,
      marginVertical: "5%",
    },
    userMessageText: {
      color: AppColors.black,
    },
    adminMessageText: {
      color: AppColors.white,
    },
    chatBox: {
      marginTop: 30,
      position: "absolute",
      right: 0,
      bottom: -150,
    },
    chatOuterView: {
      margin: 5,
      backgroundColor: AppColors.grayColor_282828,
      borderRadius: 12,
      paddingHorizontal: 10,
      marginVertical: 10,
    },
    btnChat: {
      paddingVertical: 0,
      paddingHorizontal: 15,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      shadowOpacity: 0,
      height: 40,
      marginTop: 10,
      borderRadius: 7,
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
    },
    [DEVICE_SIZES.MD]: {
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
      messageListContainer: {
        minHeight: 350,
        maxHeight: 350,
        maxWidth: 350,
        minWidth: 300,
        marginVertical: "5%",
      },
    },
    [DEVICE_SIZES.SM]: {
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
      messageListContainer: {
        minHeight: 350,
        maxHeight: 350,
        maxWidth: 350,
        minWidth: 250,
        marginVertical: "5%",
      },
      eventView: {
        marginTop: 5,
        marginBottom: 5,
        alignSelf: "center",
      },
    },
    [DEVICE_SIZES.XS]: {
      chatBox: {
        marginTop: 30,
        position: "relative",
        right: 0,
        bottom: -0,
      },
      messageListContainer: {
        minHeight: 350,
        maxHeight: 350,
        maxWidth: 350,
        minWidth: 200,
        marginVertical: "5%",
      },
      eventView: {
        marginTop: 5,
        marginBottom: 5,
        alignSelf: "center",
      },
    },
  }
);

export default withErrorBoundary(HelpChatComponent);
